'use client';

import s from './CandidateBlock.module.scss';
import CardImageItem from '../CardImageItem';
import AccordionItem from '../AccordionItem';
import Richtext from '../Richtext';
import { t } from '../../i18n';

const CandidateBlock = ({ candidate = {} }) => {
    const {
        name,
        title,
        image,
        info = [],
        governingParty,
        governingPartyTitle,
        governingPartyImage,
        governingPartyImageRectangular,
    } = candidate;

    return (
        <div className={s.Root}>
            <div className={s.Images}>
                <div className={s.Candidate}>
                    <CardImageItem
                        image={image}
                        title={title}
                        value={name}
                        hasEditorialImage={true}
                        isSquare={true}
                    />
                </div>
                <div className={s.GoverningParty}>
                    {governingParty && (
                        <CardImageItem
                            image={governingPartyImage}
                            title={governingPartyTitle}
                            value={governingParty}
                            hasEditorialImage={true}
                            subtitle={''}
                            isSquare={true}
                            useCover={false}
                            isRectangle={governingPartyImageRectangular}
                        />
                    )}
                </div>
            </div>
            <div className={s.Info}>
                {info.map((item, index) => {
                    const lowerCaseTitle = item.value.title.toLowerCase();
                    return (
                        <AccordionItem
                            blackHeaderBackground={true}
                            key={index}
                            title={`${t('general.read')} ${lowerCaseTitle}`}
                            titleOpen={`${t('general.close')} ${lowerCaseTitle}`}
                            childrenTitle={item.value.title}
                            description={''}>
                            <Richtext
                                modifier="CandidateAccordion"
                                text={item.value.content}
                            />
                        </AccordionItem>
                    );
                })}
            </div>
        </div>
    );
};

CandidateBlock.propTypes = {};

export default CandidateBlock;
